module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/partner2-6dc267feee571c05cf836f042c28c76a.png";